import { render } from "./mvt-login.vue?vue&type=template&id=667ffee5"
import script from "./mvt-login.js?vue&type=script&lang=js"
export * from "./mvt-login.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__